import { API_ROUTE_ADMIN_DEPARTMENTS } from '@/resources/api-routes'
import { post } from '@/util/auth'

import type { DepartmentOriginal } from './types'

const IS_NEW_BACKEND_API = true

export const createDepartment = async ({
  payload,
}: {
  payload: Pick<
    DepartmentOriginal,
    | 'name'
    | 'code'
    | 'customerId'
    | 'userId'
    | 'deputyUserId'
    | 'project'
    | 'deputyMail'
    | 'inactive'
  >
}) =>
  (
    await post<{ department: DepartmentOriginal }>(
      API_ROUTE_ADMIN_DEPARTMENTS,
      payload,
      IS_NEW_BACKEND_API
    )
  ).department
